const KEY_ACCESS_TOKEN = 'goldie:auth:accessToken'
const KEY_REFRESH_TOKEN = 'goldie:auth:refreshToken'
const KEY_EXPIRES_AT = 'goldie:auth:expiresAt'

export interface StoredTokens {
  accessToken: string
  refreshToken: string
  expiresAt: number // Unix timestamp (seconds)
}

export const setTokens = ({
  accessToken,
  refreshToken,
  expiresAt
}: StoredTokens): void => {
  localStorage.setItem(KEY_ACCESS_TOKEN, accessToken)
  localStorage.setItem(KEY_REFRESH_TOKEN, refreshToken)
  localStorage.setItem(KEY_EXPIRES_AT, String(expiresAt))
}

export const getTokens = (): StoredTokens | null => {
  const accessToken = localStorage.getItem(KEY_ACCESS_TOKEN)
  const refreshToken = localStorage.getItem(KEY_REFRESH_TOKEN)
  const expiresAtStr = localStorage.getItem(KEY_EXPIRES_AT)

  if (accessToken === null || refreshToken === null || expiresAtStr === null) {
    return null
  }

  return {
    accessToken,
    refreshToken,
    expiresAt: Number(expiresAtStr)
  }
}

export const clearTokens = (): void => {
  localStorage.removeItem(KEY_ACCESS_TOKEN)
  localStorage.removeItem(KEY_REFRESH_TOKEN)
  localStorage.removeItem(KEY_EXPIRES_AT)
}

export const isAccessTokenExpired = (): boolean => {
  const tokens = getTokens()
  if (tokens === null) return true
  return tokens.expiresAt <= Date.now() / 1000
}

export const expiresInSeconds = (): number => {
  const tokens = getTokens()
  if (tokens === null) return 0
  return tokens.expiresAt - Date.now() / 1000
}

export const decodeAccessToken = (): Record<string, unknown> | null => {
  const tokens = getTokens()
  if (tokens === null) return null

  try {
    const parts = tokens.accessToken.split('.')
    if (parts.length !== 3) return null

    // Pad base64url to standard base64 then decode
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = payload + '=='.slice(0, (4 - (payload.length % 4)) % 4)
    const decoded = atob(padded)
    return JSON.parse(decoded) as Record<string, unknown>
  } catch {
    return null
  }
}
